(function resetRemUnit() {
    const MaxWidth = 500;
    const docEl = document.documentElement;
    function setMaxRemUnit() {
        let width = docEl.clientWidth;
        if (docEl.clientWidth > MaxWidth) {
            width = MaxWidth;
        }
        docEl.style.fontSize = `${width / 10}px`;
    }

    setMaxRemUnit();

    window.addEventListener('resize', setMaxRemUnit);
    window.addEventListener('pageshow', e => {
        if (e.persisted) {
            setMaxRemUnit();
        }
    });
})();
